// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"b87333af","220":"19847b9f","352":"ec056473","803":"19847b9f","931":"02c17d0c"}[chunkId] + ".css";
};